// Auth0 solo admite alfanuméricos y los caracteres _ + - . ! # $ ' ^ ` ~ @
export const AUTH0_USERNAME_PATTERN = /^[a-zA-Z0-9_+.!#$'^`~@-]+$/;

const sanitizeUsernamePart = (value) =>
  `${value || ""}`
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const buildAuth0Username = (firstName, lastName, identification) => {
  const firstPart = sanitizeUsernamePart(firstName).slice(0, 2);
  const lastPart = sanitizeUsernamePart(lastName).slice(0, 2);
  const identificationPart = sanitizeUsernamePart(identification).slice(-5);

  return `${firstPart}${lastPart}${identificationPart}`;
};

export const isValidAuth0Username = (value) =>
  AUTH0_USERNAME_PATTERN.test(`${value || ""}`);
